<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Vulnerability</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="vulnerability_consent_method_id"
            :options="vulnerabilityConsentMethods"
            v-model="form.vulnerability_consent_method_id"
            label="Consent Method"
            placeholder="Please Select"
            helper="Please select the vulnerability consent method"
            :error-message="form.errors.get('vulnerability_consent_method_id')"
            :show-error="form.errors.has('vulnerability_consent_method_id')"
          ></selectlist>

          <selectlist
            name="vulnerability_code_id"
            :options="vulnerabilityCodes"
            v-model="form.vulnerability_code_id"
            label="Vulnerability Code"
            placeholder="Please Select"
            helper="Please select the vulnerability Code"
            :error-message="form.errors.get('vulnerability_code_id')"
            :show-error="form.errors.has('vulnerability_code_id')"
          ></selectlist>

          <input-block
            v-model="form.information_provided"
            name="information_provided"
            label="Information Provided"
            helper="Please enter the information client has provided about their vulnerability"
            :error-message="form.errors.get('information_provided')"
            :show-error="form.errors.has('information_provided')"
          ></input-block>

          <input-block
            v-model="form.support_required"
            name="support_required"
            label="Support Required"
            helper="Please enter the support the client requires"
            :error-message="form.errors.get('support_required')"
            :show-error="form.errors.has('support_required')"
          ></input-block>

          <input-block
            v-model="form.support_provided"
            name="support_provided"
            label="Support Provided"
            helper="Please enter the details of the support we have provided for the client"
            :error-message="form.errors.get('support_provided')"
            :show-error="form.errors.has('support_provided')"
          ></input-block>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button
        :indicator="form.processing()"
        v-on:clicked="addVulnerability"
        >Add New Vulnerability</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    vulnerabilityConsentMethods: {
      type: Array,
      required: true
    },

    vulnerabilityCodes: {
      type: Array,
      required: true
    },

    client: {
      type: Object
    }
  },

  data() {
    return {
      form: new window.Form({
        vulnerability_consent_method_id: null,
        vulnerability_code_id: null,
        information_provided: null,
        support_required: null,
        support_provided: null
      })
    };
  },

  computed: {},

  methods: {
    closeModal() {
      this.$emit('close');
    },

    addVulnerability() {
      this.form
        .post(
          '/incidents/' +
            this.incident +
            '/client/' +
            this.client.identifier +
            '/vulnerability'
        )
        .then(response => {
          this.$emit('added', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error creating the vulnerability.'
          );
        });
    }
  }
};
</script>
